






















































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import nationSelect from '@/components/common/nationSelect.vue';
import deptSelect from '@/components/common/deptSelect.vue';
import birthDate from '@/components/common/birthdate.vue';
import confirmFeedback from '@/components/common/confirmFeedback.vue';
import axios from 'axios';
import UserModule from '@/store/modules/user';
import { Notify, Dialog } from 'vant';
import * as api from '@/api';
import manageRank from '@/components/common/manageRank.vue';
import unManageRank from '@/components/common/unManageRank.vue';

@Component({
  components: { nationSelect, deptSelect, confirmFeedback, manageRank, unManageRank },
})
export default class extends Vue {
  @Prop() personInfo: any;
  @Watch('personInfo', { deep: true, immediate: true })
  onCurrentPersonInfoAsync(val: any) {
    this.form = val;
    if (this.form.imageName) {
      this.getStuImg('学员头像', this.form.imageName);
    }
  }
  feedbackShow: boolean = false;
  feedbackType: string = '';
  successStatu: boolean = false;
  errorMsg: string = '';
  loading: boolean = false;
  finished: boolean = false;
  previewImg: any = '';
  showNationPicker: boolean = false;
  showDeptPicker: boolean = false;
  stuImgs: any = [];
  ajaxUrl: any = apiAxios.getUri;
  form: Partial<any> = {
    id: '',
    deptId: '',
    deptName: '',
    imageName: '',
    name: '',
    sex: '',
    nation: '',
    workUnit: '',
    job: '',
    birthday: '',
    postRank: null,
    unManageRank: null,
  };

  postRankValue: string = '';
  unManageRankValue: string = '';
  showUnManageRankPicker: boolean = false; // 非管理职级组件显隐
  showManageRankPicker: boolean = false;

  deptBind(depts: any) {}

  manRankConfirm(val) {
    this.form.postRank = val.order;
    this.postRankValue = val.name;
    this.showManageRankPicker = false;
  }
  unManRankConfirm(val) {
    this.form.unManageRank = val.order;
    this.unManageRankValue = val.name;
    this.showUnManageRankPicker = false;
  }

  async onSubmit() {
    if (this.form.unManageRank == null && this.form.postRank == null) {
      Dialog.alert({
        title: '提示',
        message: '职务层次与职级至少要填写一个！',
      });
      return;
    }
    try {
      let that = this;
      that.feedbackShow = true;
      const { data, success, message } = await api.AccountApp.editStudentInfo_POST(this.form);
      if (success) {
        that.successStatu = true;
        setTimeout(() => {
          that.$emit('psEditSuccess');
        }, 2000);
      } else {
        that.successStatu = false;
        that.errorMsg = message;
      }
      UserModule.GetInfo();
      location.reload();
    } finally {
      this.loading = false;
      this.finished = true;
    }
    this.feedbackType = '学员信息';
  }
  //关闭提交状态对话框回调事件
  feedbaclCancle() {
    this.feedbackShow = false;
  }
  nationConfirm(val: string) {
    this.showNationPicker = false;
    this.form.nation = val;
  }
  nationCancel() {
    this.showNationPicker = false;
  }
  deptConfirm(dept: any) {
    this.showDeptPicker = false;
    this.form.deptName = dept.deptName;
    this.form.deptId = dept.deptId;
  }
  deptCancel() {
    this.showDeptPicker = false;
  }
  beforeUpload(file: any) {
    if (file.type != 'image/jpeg' && file.type != 'image/png') {
      Dialog.alert({
        message: '请上传jpg或png格式的图片',
      });
      return false;
    }
    return true;
  }
  async afterUpload(file: any) {
    let _this = this;
    _this.stuImgs = [];
    _this.previewImg = file.content;
    _this.form.imageName = _this.genGuid();
    await _this.uploadFile(file, _this.form.imageName);
  }
  async uploadFile(file: any, key: string) {
    let formData = new FormData();
    formData.append('file', file.file);
    formData.append('StringKey1', key);
    formData.append('Category', '学员头像');
    try {
      await apiAxios
        .post('/api/NewAttachment/Upload', formData, axiosOptions)
        .then(res => {})
        .catch(err => {});
    } catch (err) {
      Dialog.alert({
        message: '上传失败',
      });
    }
  }
  // 获取学员头像
  async getStuImg(keyName: string, key: string) {
    const { data } = await apiAxios.get('/api/NewAttachment/GetAttachmens', {
      params: {
        StringKey1: key,
        Category: keyName,
      },
    });
    this.stuImgs = data;
  }
  genGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);
